import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderList as _renderList, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a6e417a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MapFooter" }
const _hoisted_2 = { class: "MapFooter__address" }
const _hoisted_3 = { class: "address__description" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Геокодирование при помощи ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Yandex")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("2GIS")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "address__title" }, "Выбранный адрес:", -1))
const _hoisted_8 = { class: "address__result" }
const _hoisted_9 = { class: "address__text" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Геокодируем адрес... ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Ошибка при поиске адреса ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Поставьте точку на карте ")
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { id: "app" }
const _hoisted_15 = { class: "header" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info__wrap" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "info__title" }, "Электронная форма заказа"),
    /*#__PURE__*/_createElementVNode("p", { class: "info__description" }, " Для доставки гарантийного инструмента в авторизованные сервисные центры ТОО \"Роберт Бош\" для физических лиц ")
  ])
], -1))
const _hoisted_17 = { class: "form" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Отправитель")
], -1))
const _hoisted_19 = { class: "form__body" }
const _hoisted_20 = { class: "form__row" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Для создания заказа, необходимо добавить хотябы 1 инструмент ")
const _hoisted_22 = { class: "form" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Груз")
], -1))
const _hoisted_24 = { class: "form__body" }
const _hoisted_25 = { class: "offers" }
const _hoisted_26 = { class: "form__checkbox" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__text" }, " С условиями предоставления сервиса по заполнению электронного заказа ознакомлен ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "offers__link",
  href: "https://www.bosch-professional.com/kz/ru/servis/posleprodazhnoe-obsluzhivanie/remontnaya-sluzhba/sdacha-v-remont-onlayn/",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Ознакомиться ", -1))
const _hoisted_29 = { class: "form__checkbox" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__text" }, " C гарантийными условиями ознакомлен ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "offers__link",
  href: "https://www.bosch-professional.com/kz/media/country_content/service/online_repair_service/guarantee_terms.pdf",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Ознакомиться ", -1))
const _hoisted_32 = { class: "form__checkbox" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__text" }, " С условиями договора об указании услуг перевозки грузов ознакомлен ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "offers__link",
  href: "https://spark.kz/offer",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Ознакомиться ", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Необходимо заполнить все обязательные* поля корректно ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Отправить оператору")
const _hoisted_37 = {
  key: 1,
  class: "loader large"
}
const _hoisted_38 = {
  key: 1,
  class: "success"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "success__message" }, "Ваш заказ отправлен", -1))
const _hoisted_40 = { class: "year" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_authorize_loader = _resolveComponent("authorize-loader")!
  const _component_map_search = _resolveComponent("map-search")!
  const _component_map_component = _resolveComponent("map-component")!
  const _component_modal = _resolveComponent("modal")!
  const _component_spark_logo = _resolveComponent("spark-logo")!
  const _component_bosch_logo = _resolveComponent("bosch-logo")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_alert = _resolveComponent("alert")!
  const _component_tool = _resolveComponent("tool")!
  const _component_tool_form = _resolveComponent("tool-form")!
  const _component_icon_check = _resolveComponent("icon-check")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.auth_state.is_loading)
      ? (_openBlock(), _createBlock(_component_authorize_loader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.state.map_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.map_opened = false))
        }, {
          body: _withCtx(() => [
            _createVNode(_component_map_component, {
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.map_opened = false)),
              onClick: _ctx.mapClicked,
              onMapCreated: _ctx.mapCreated,
              onMapSwitched: _ctx.mapSwitched
            }, {
              layer: _withCtx(() => [
                _createVNode(_component_map_search, {
                  city: _ctx.sender_state.city,
                  "geocode-by-yandex": _ctx.map_state.is_yandex,
                  "geocode-by-gis": _ctx.map_state.is_gis,
                  onSelect: _ctx.resultFinded
                }, null, 8, ["city", "geocode-by-yandex", "geocode-by-gis", "onSelect"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("b", null, [
                        (_ctx.map_state.is_yandex)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_5
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.map_state.is_gis)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_6
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        (_ctx.address_state.is_loading)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_10
                            ], 64))
                          : (_ctx.address_state.is_failed)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_11
                              ], 64))
                            : (!_ctx.address_state.is_finded)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_12
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createTextVNode(_toDisplayString(_ctx.address_state.address), 1)
                                ], 64))
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-medium btn-default",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setFullAddress && _ctx.setFullAddress(...args))),
                    disabled: !_ctx.address_state.is_finded
                  }, " Подтвердить ", 8, _hoisted_13)
                ])
              ]),
              _: 1
            }, 8, ["onClick", "onMapCreated", "onMapSwitched"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("header", _hoisted_15, [
        _createVNode(_component_spark_logo, {
          class: "header__logo header__logo--left",
          alt: "Spark Logistics"
        }),
        _createVNode(_component_bosch_logo, {
          class: "header__logo header__logo--right",
          alt: "Bosch"
        })
      ]),
      (!_ctx.state.is_submited)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.sender_form$.fio.$error,
                        }]),
                  placeholder: "Фамилия Имя Отчество *",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sender_state.fio) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.sender_state.fio,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.sender_form$.phone.$error,
                        }]),
                  placeholder: "Номер телефона *",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sender_state.phone) = $event))
                }, null, 2), [
                  [_directive_maska, '+7 (###) ###-##-##'],
                  [
                    _vModelText,
                    _ctx.sender_state.phone,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(_component_multiselect, {
                  class: _normalizeClass(["form__select", { invalid: _ctx.sender_form$.city.$error }]),
                  object: true,
                  options: _ctx.additional_state.cities,
                  canDeselect: true,
                  canClear: true,
                  searchable: "",
                  trackBy: "name",
                  label: "name",
                  valueProp: "id",
                  modelValue: _ctx.sender_state.city,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sender_state.city) = $event)),
                  placeholder: "Город *",
                  loading: _ctx.additional_state.is_cities_loading,
                  onSelect: _ctx.onCitySelected,
                  noOptionsText: "Список пуст",
                  noResultsText: "Нет результатов по вашему запросу"
                }, null, 8, ["class", "options", "modelValue", "loading", "onSelect"]),
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.sender_state.service_center,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sender_state.service_center) = $event)),
                  class: _normalizeClass(["form__select", { invalid: _ctx.sender_form$.service_center.$error }]),
                  object: true,
                  options: _ctx.additional_state.services,
                  canDeselect: true,
                  canClear: true,
                  searchable: "",
                  trackBy: "title",
                  label: "title",
                  valueProp: "id",
                  placeholder: "Сервисный центр *",
                  loading: _ctx.additional_state.is_services_loading,
                  noOptionsText: "Список пуст",
                  noResultsText: "Нет результатов по вашему запросу"
                }, null, 8, ["modelValue", "class", "options", "loading"]),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form__input form__col", {
                                'form__input--invalid': _ctx.sender_form$.full_address.$error,
                            }]),
                    disabled: "",
                    placeholder: "Полный адрес *",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sender_state.full_address) = $event))
                  }, null, 2), [
                    [
                      _vModelText,
                      _ctx.sender_state.full_address,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-medium btn-default map form__col",
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)))
                  }, " Указать на карте ")
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email",
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.sender_form$.email.$error,
                        }]),
                  placeholder: "E-mail *",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sender_state.email) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.sender_state.email,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  id: "customer_requirement",
                  class: _normalizeClass(["form__textarea", {
                            'form__textarea--invalid': _ctx.sender_form$.customer_requirement.$error,
                        }]),
                  placeholder: "Требования клиента",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sender_state.customer_requirement) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.sender_state.customer_requirement]
                ])
              ])
            ]),
            (_ctx.state.tools.length < 1)
              ? (_openBlock(), _createBlock(_component_alert, {
                  key: 0,
                  class: _normalizeClass({
                    'alert-warn': !_ctx.state_form$.tools.$error,
                    'alert-error': _ctx.state_form$.tools.$error,
                })
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tools, (tool, i) => {
              return (_openBlock(), _createBlock(_component_tool, {
                key: `CompletedTool-${i}`,
                tool: tool,
                index: i,
                onDelete: _ctx.deleteTool
              }, null, 8, ["tool", "index", "onDelete"]))
            }), 128)),
            (!_ctx.state.is_adding_tool)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.is_adding_tool = true)),
                  class: "btn addmore mt-16"
                }, " Добавить инструмент "))
              : _createCommentVNode("", true),
            (_ctx.state.is_adding_tool)
              ? (_openBlock(), _createBlock(_component_tool_form, {
                  key: 2,
                  onSubmit: _ctx.addTool
                }, null, 8, ["onSubmit"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.cargo_form$.weight.$error,
                        }]),
                  placeholder: "Вес (кг) *",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cargo_state.weight) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.cargo_state.weight,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "length",
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.cargo_form$.length.$error,
                        }]),
                  placeholder: "Длина (см) *",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cargo_state.length) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.cargo_state.length,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "height",
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.cargo_form$.height.$error,
                        }]),
                  placeholder: "Высота (см) *",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cargo_state.height) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.cargo_state.height,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "width",
                  class: _normalizeClass(["form__input", {
                            'form__input--invalid': _ctx.cargo_form$.width.$error,
                        }]),
                  placeholder: "Ширина (см) *",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.cargo_state.width) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.cargo_state.width]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: _normalizeClass(["checkbox__square", {
                                'checkbox__square--invalid': _ctx.agreements_form$.agree_service.$error,
                            }]),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.agreements_state.agree_service) = $event))
                  }, null, 2), [
                    [
                      _vModelCheckbox,
                      _ctx.agreements_state.agree_service,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _hoisted_27
                ]),
                _hoisted_28,
                _createElementVNode("label", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: _normalizeClass(["checkbox__square", {
                                'checkbox__square--invalid':
                                    _ctx.agreements_form$.agree_guarantee.$error,
                            }]),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.agreements_state.agree_guarantee) = $event))
                  }, null, 2), [
                    [_vModelCheckbox, _ctx.agreements_state.agree_guarantee]
                  ]),
                  _hoisted_30
                ]),
                _hoisted_31,
                _createElementVNode("label", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: _normalizeClass(["checkbox__square", {
                                'checkbox__square--invalid': _ctx.agreements_form$.agree_contract.$error,
                            }]),
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.agreements_state.agree_contract) = $event))
                  }, null, 2), [
                    [
                      _vModelCheckbox,
                      _ctx.agreements_state.agree_contract,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _hoisted_33
                ]),
                _hoisted_34
              ])
            ]),
            (
                    Boolean(_ctx.sender_form$.$errors.length) ||
                    Boolean(_ctx.cargo_form$.$errors.length) ||
                    Boolean(_ctx.agreements_form$.$errors.length)
                )
              ? (_openBlock(), _createBlock(_component_alert, {
                  key: 3,
                  class: "alert-error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "mt-16 btn btn-green btn-large",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.submitOrder && _ctx.submitOrder(...args))),
              type: "button"
            }, [
              (!_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_36
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_37))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createVNode(_component_icon_check),
            _hoisted_39
          ])),
      _createElementVNode("span", _hoisted_40, " 2020 - " + _toDisplayString(new Date(Date.now()).getFullYear()), 1)
    ])
  ], 64))
}